import BaseService from '@/features/BaseService';

export default class CalledStatusService extends BaseService {
  constructor() {
    super('called-status');
  }
}



// WEBPACK FOOTER //
// ./src/features/called-status/CalledStatusService.js